export const HOME = "/";
export const LOGIN = `${HOME}login`;
export const REGISTER = `${HOME}register`;
export const RANKINGS = `${HOME}rankings`;
export const CHALLENGES = `${HOME}challenges`;
export const SINGLE_CHALLENGE = `${CHALLENGES}/:id`;
export const SANDBOX = `${HOME}sandbox`;
export const INSTRUCTIONS = `${HOME}instructions`;
export const ADMIN = `${HOME}admin`;
export const CREATE = "create";
export const PUBLISHED = "published";
export const SETTINGS = "settings";
export const TEAM = `${HOME}team/:name`;
export const PAGE_NOT_FOUND = "*";
export const UPDATE_TABLE = "update-table";
export const ALGORITHMS = "algorithms";
export const SCRIPTING = "scripting";
export const SQL = "sql";
export const SAVE = "save";
export const PUBLISH = "publish";
